import React from "react";
import { Link } from "react-router-dom";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { IconContext } from "react-icons/lib";
import styles from "./NavCard.module.css";

const NavCard = ({ icon, text, buttonText, link }) => {
  const handleButtonDisplay = () => {
    // if (buttonText === "Logout") {
    //   return (
    //     <Button variant="contained" onClick={handleLogout}>
    //       {buttonText}
    //     </Button>
    //   );
    // }

    if (buttonText === "Create a new file") {
      return (
        <Link to="new">
          <Button variant="contained">{buttonText}</Button>
        </Link>
      );
    }

    return (
      <Link to={link}>
        <Button variant="contained">{buttonText}</Button>
      </Link>
    );
  };

  return (
    <Box
      sx={{
        backgroundColor: "#f1f1f1",
        borderRadius: "10px",
        width: "275px",
        padding: "20px",
      }}
    >
      <IconContext.Provider value={{ className: styles.icons }}>
        <Box className="icon-container">{icon}</Box>
      </IconContext.Provider>

      <p className={styles.cardText}>{text}</p>

      {handleButtonDisplay()}
    </Box>
  );
};

export default NavCard;
